import userFields from '@/app/modules/users/monetic/fields/userFields';
import { client } from '../../../../../common-utils/libraries/axios/axios';
import SESSION from '../apiUrls';

/**
 * @param responseData response.data object
 * @param responseData.hasMfa boolean
 *
 * @param data
 * @returns Mapped data object
 */
function mapResponseData(data) {
    return data[userFields.ADVANCED_AUTH.key];
}

const queryGetMfa = () => {
    return {
        queryKey: [SESSION.FETCH_MFA_ACTIVATION.queryKey],
        queryFn: async () => {
            const response = await client.get(SESSION.FETCH_MFA_ACTIVATION.url);
            return mapResponseData(response.data);
        }
    };
};

export default queryGetMfa;